import type { PinRendererProps } from './pinMediaRenderer';

export function ImagePin({ pin }: PinRendererProps) {
  return (
    <img
      src={pin.url ?? ''}
      alt=""
      className="max-h-full max-w-full object-contain"
    />
  );
}
